/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EnvironmentEntry,
  EnvironmentEntry$inboundSchema,
} from "./environmententry.js";

/**
 * Model representing an environment
 */
export type Environment = {
  /**
   * The creation date of the environment
   */
  createdAt: Date;
  /**
   * The description of the environment
   */
  description?: string | undefined;
  /**
   * List of environment entries
   */
  entries: Array<EnvironmentEntry>;
  /**
   * The ID of the environment
   */
  id: string;
  /**
   * The name of the environment
   */
  name: string;
  /**
   * The organization ID this environment belongs to
   */
  organizationId: string;
  /**
   * The project ID this environment belongs to
   */
  projectId: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
  /**
   * When the environment was last updated
   */
  updatedAt: Date;
};

/** @internal */
export const Environment$inboundSchema: z.ZodMiniType<Environment, unknown> = z
  .pipe(
    z.object({
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      description: z.optional(z.string()),
      entries: z.array(EnvironmentEntry$inboundSchema),
      id: z.string(),
      name: z.string(),
      organization_id: z.string(),
      project_id: z.string(),
      slug: z.string(),
      updated_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        "created_at": "createdAt",
        "organization_id": "organizationId",
        "project_id": "projectId",
        "updated_at": "updatedAt",
      });
    }),
  );

export function environmentFromJSON(
  jsonString: string,
): SafeParseResult<Environment, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Environment$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Environment' from JSON`,
  );
}
